var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_666_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60646 33.5046L19.1313 11.5419C19.515 10.8691 20.4849 10.8691 20.8686 11.5419L33.3935 33.5046C33.7736 34.1713 33.2922 35 32.5248 35H7.47514C6.7077 35 6.22629 34.1713 6.60646 33.5046Z",
    stroke: "#3A3F60",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4521 29.5484V25.4516C21.4521 24.6499 20.8021 24 20.0004 24C19.1987 24 18.5488 24.6499 18.5488 25.4516V29.5484C18.5488 30.3501 19.1987 31 20.0004 31C20.8021 31 21.4521 30.3501 21.4521 29.5484Z",
    stroke: "#3A3F60",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4198 19.5C21.4198 20.3596 20.7536 21 20.0004 21C19.2472 21 18.5811 20.3596 18.5811 19.5C18.5811 18.6404 19.2472 18 20.0004 18C20.7536 18 21.4198 18.6404 21.4198 19.5Z",
    stroke: "#3A3F60",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 27,
    fill: "white",
    transform: "translate(5 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.b230cc40.svg";
export { ForwardRef as ReactComponent };